import daBoiAvatar from "../client/static/da-boi.webp";
import kivo from "../client/static/examples/kivo.webp";
import messync from "../client/static/examples/messync.webp";
import microinfluencerClub from "../client/static/examples/microinfluencers.webp";
import promptpanda from "../client/static/examples/promptpanda.webp";
import reviewradar from "../client/static/examples/reviewradar.webp";
import scribeist from "../client/static/examples/scribeist.webp";
import searchcraft from "../client/static/examples/searchcraft.webp";
import { BlogUrl, DocsUrl } from "../shared/common";

export interface GridFeature {
  name: string;
  description: string;
  emoji: string;
  href: string;
  size?: 'small' | 'medium' | 'large';
}

export const features: GridFeature[] = [
  {
    name: 'Multi-vertical packs',
    description: 'Ship the same app for malls, apartments, campuses, coworking, or mixed portfolios via location-type packs.',
    emoji: '🏢',
    href: DocsUrl,
    size: 'large',
  },
  {
    name: 'Location pages',
    description: 'Give every building its own notices, events, and services with section visibility controls.',
    emoji: '🗺️',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Community updates',
    description: 'Publish notices and events that fit residents, tenants, students, or shoppers.',
    emoji: '📅',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Residences & amenities',
    description: 'Surface housing, dining, and amenity info without hard-coding a university layout.',
    emoji: '🏠',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Retail & common areas',
    description: 'Highlight food courts, shops, and shared spaces for shopping-center deployments.',
    emoji: '🛍️',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Operations tools',
    description: 'Approvals, permissions, and recycle bin workflows for portal operators.',
    emoji: '⚙️',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Instance branding',
    description: 'Set brand name, subtitle, and vertical pack per deployment from Global Settings.',
    emoji: '🎨',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Control plane ready',
    description: 'Register segregated or shared-location instances from a centralized control plane.',
    emoji: '🛰️',
    href: DocsUrl,
    size: 'small',
  },
];

export const testimonials = [
  {
    name: 'Alexander Thompson',
    role: 'Apartment community manager',
    avatarSrc: daBoiAvatar,
    socialUrl: 'https://twitter.com/wasplang',
    quote: "Gedoba gives residents one place for notices, amenities, and building updates without a custom app for each tower.",
  },
  {
    name: 'Maria Garcia',
    role: 'Mall operations lead',
    avatarSrc: daBoiAvatar,
    socialUrl: '',
    quote: "We run food court and tenant updates from the same portal pattern we use for offices — branding and packs do the heavy lifting.",
  },
  {
    name: 'Lucas Wright',
    role: 'Campus digital services',
    avatarSrc: daBoiAvatar,
    socialUrl: '#',
    quote: "Shared or segregated instances still land in one control plane, which makes portfolio rollouts far simpler.",
  },
];

export const faqs = [
  {
    id: 1,
    question: 'Can this run for a mall or apartment complex, not just a campus?',
    answer: 'Yes. Configure Instance Branding and location-type packs for retail, residential, education, coworking, or mixed portfolios — same codebase.',
  },
  {
    id: 2,
    question: 'How do segregated vs shared deployments work?',
    answer: 'SEGREGATED gives each customer their own app and Postgres. SHARED_LOCATIONS keeps many buildings in one DB under one operator. Both are registered in the control plane.',
  },
  {
    id: 3,
    question: 'Where do I change brand name and vertical?',
    answer: 'Admins can edit brand name, subtitle, and vertical pack under Admin → Global Settings → Instance Branding.',
  },
  {
    id: 4,
    question: 'Is demo seed data required?',
    answer: 'No. Sample campus locations are optional demo data. Production instances start from branding + packs for your vertical.',
  },
];

export const footerNavigation = {
  company: [
    { name: 'About', href: '/about' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Use', href: '/terms' },
    { name: 'Contact Admin', href: '/contact' },
  ],
};

export const examples = [
  {
    name: 'Metro shopping center',
    description: 'Retail floors, food court, and tenant updates in one portal.',
    imageSrc: kivo,
    href: '#',
  },
  {
    name: 'Sunset residential towers',
    description: 'Resident notices, amenities, and building services for apartment portfolios.',
    imageSrc: messync,
    href: '#',
  },
  {
    name: 'North campus hub',
    description: 'Shared-locations mode for faculties, dorms, and student centers.',
    imageSrc: microinfluencerClub,
    href: '#',
  },
  {
    name: 'Coworking floors',
    description: 'Member events, desk amenities, and operator announcements.',
    imageSrc: promptpanda,
    href: '#',
  },
  {
    name: 'Community center',
    description: 'Programs, help desk, and local group activity for neighborhood sites.',
    imageSrc: reviewradar,
    href: '#',
  },
  {
    name: 'Mixed-use district',
    description: 'Offices, retail, and residences under one operator branding pack.',
    imageSrc: scribeist,
    href: '#',
  },
  {
    name: 'Innovation hub',
    description: 'Labs, makerspaces, and shared facilities with custom section flags.',
    imageSrc: searchcraft,
    href: '#',
  },
];
